import $http from '$http'
import {
    lg,
    util
} from 'utils';

export default {
    methods: {
        // 获取事件类型
        getInitData() {
            var params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                pageIndex: 1,
                pageSize: 1000,
            };
            this.MatterTypes = [];
            let type0 = {
                'Id': 0,
                'MatterTypeName': '-请选择-'
            }
            this.loading = true; //拼命加载中显示
            $http.get('api/Bing/GetMatterType_List', params).then(res => {
                let {
                    StateCode,
                    StateMsg,
                    Data,
                    Cnt
                } = res.data;
                util.doResult(this, res, () => {
                    this.MatterTypes = Data
                    this.MatterTypes.unshift(type0) //处理"MatterTypeId": 0
                    this.loading = false; //拼命加载中隐藏
                });
            });
        },
        // 修改特殊事项
        getMatterData(id) {
            var params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                Id: id
            };
            this.loading = true; //拼命加载中显示
            $http.get('api/Bing/GetMatterById', params).then(res => {
                let {
                    StateCode,
                    StateMsg,
                    Data,
                    Cnt
                } = res.data;
                util.doResult(this, res, () => {
                    this.submitFormData = $.extend({}, this.submitFormData, Data);
                    let $obj = this.submitFormData.AttaUrl
                    for (let i = 0; i < $obj.length; i++) {
                        $obj[i].Name = $obj[i].Url.split("/").pop();
                    }
                    this.loading = false; //拼命加载中隐藏
                });
            });
        },
        // 添加事件类型
        submitMatter() {
            var params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
            };
            let query = {}
            query.MatterTypeName = this.MatterTypeName
            params = Object.assign({}, params, query);
            $http.post('api/Bing/ERP_MatterTypeAdd', params).then(res => {
                util.doResult(this, res, () => {
                    this.$notify({
                        title: '成功',
                        message: '添加成功！',
                        type: 'success'
                    });
                    this.MatterVisible = false
                    this.getInitData();
                });
            });
        },
        // 提交添加/修改特殊事项
        submitMatterType(data) {
            var params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
            };
            params = Object.assign({}, params, data);
            let $href = '';
            let msg = ''
            if (this.isChange) {
                $href = 'api/Bing/ERP_MatterUpdate'
                msg = '修改成功'
            } else {
                $href = 'api/Bing/ERP_MatterAdd'
                msg = '添加成功'
            }
            $http.post($href, params).then(res => {
                util.doResult(this, res, () => {
                    this.$notify({
                        title: '成功',
                        message: msg,
                        type: 'success'
                    });
                    this.dialogClose();
                    this.$emit('reLoadList')
                });
            });
        },
    }
};


// WEBPACK FOOTER //
// ./src/pages/Memorandum/SpecialMatter/components/addSpecialMatter/services.js